import { IDropdownProps } from 'legacy/lut/library/dropdown'
import React from 'react'

import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { OnboardingDropdown } from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'

import { IPartnerShipNA, IPartnerShipNaCrudExtended } from './types'

interface IProps {
  onChange: (field: string) => (value: string) => void
  crud: IPartnerShipNaCrudExtended
  item: IPartnerShipNA
  writeAudience: IObjectAny
  disabled?: boolean
}

export const DiversityNa = ({ onChange, crud, item, writeAudience, disabled }: IProps) => {
  return (
    <div>
      <div className={styles.text__title}>
        Diversity <div className={styles.text__rule}>{`(Applies to T1 & T2 Reseller)`}</div>
      </div>
      <VisualAudienceExtended<IDropdownProps>
        component={OnboardingDropdown}
        write={writeAudience}
        margin={'md'}
        label={'What´s your preferred Distributor? Please provide the name'}
        value={item.Distributor}
        onChange={onChange('Distributor')}
        disabled={disabled}
        source={crud.Distributors}
        caption={'en'}
      />
      <VisualAudienceExtended<IDropdownProps>
        component={OnboardingDropdown}
        write={writeAudience}
        margin={'md'}
        label={'How long have you been working with this Distributor?'}
        source={crud.Duration}
        value={item.Duration || ''}
        caption={'label'}
        onChange={onChange('Duration')}
        disabled={disabled}
      />
    </div>
  )
}
